import { writable } from 'svelte/store';
import type { Drawer } from '@Shelly/shelly-design-system/index';

import { getDrawerState, type SidePanelStateType } from '../ui/sidepanel';

/** @deprecated Legacy drawer path — remove when old layout is gone. */
export const drawerRef = writable<Drawer>();

/** @deprecated Legacy drawer path — remove when old layout is gone. */
export const drawerState = writable<SidePanelStateType>(getDrawerState());

/** @deprecated Legacy drawer path — remove when old layout is gone. */
export const drawerRedirect = writable<boolean>(false);
